import isValid from 'date-fns/isValid';
import parse from 'date-fns/parse';
export var EMAIL_REGEXP = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export var PHONE_REGEXP = /^\+7\s\(\d{3}\)\s\d{3}-\d{2}-\d{2}$/;
export var REPAIR_PHONE_REGEXP = /^\d{3}\s\d{3}-\d{2}-\d{2}$/;
export var REPAIR_PHONE_PASTE_REGEXP = /^[78]\d{10}$/;
export var validationPipe = function validationPipe() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }
  return function () {
    for (var _len2 = arguments.length, fieldValidatorArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      fieldValidatorArgs[_key2] = arguments[_key2];
    }
    return validators.reduce(function (error, validator) {
      return error || validator.apply(void 0, fieldValidatorArgs);
    }, undefined);
  };
};
export var testValidator = function testValidator(_ref) {
  var regExp = _ref.regExp,
    _ref$message = _ref.message,
    message = _ref$message === void 0 ? 'Значение не корректно' : _ref$message;
  return function (value) {
    if (regExp.test(value)) {
      return;
    }
    return message;
  };
};
export var customValidator = function customValidator(_ref2) {
  var callback = _ref2.callback,
    _ref2$message = _ref2.message,
    message = _ref2$message === void 0 ? 'Значение не корректно' : _ref2$message;
  return function (value) {
    if (callback(value)) {
      return;
    }
    return message;
  };
};
export var notEmptyValidator = function notEmptyValidator() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      message: 'Обязательное поле'
    },
    message = _ref3.message;
  return function (value) {
    if (value == null) {
      return message;
    }
    if (Boolean(value) === false) {
      return message;
    }
    if (typeof value === 'string' && value.trim().length === 0) {
      return message;
    }
    return;
  };
};
export var emailValidator = function emailValidator() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      message: 'Неправильный email'
    },
    message = _ref4.message;
  return testValidator({
    regExp: EMAIL_REGEXP,
    message: message
  });
};
export var phoneValidator = function phoneValidator() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      message: 'Неправильный номер'
    },
    message = _ref5.message;
  return testValidator({
    regExp: PHONE_REGEXP,
    message: message
  });
};
export var repairPhoneValidator = function repairPhoneValidator() {
  return function (value) {
    //TODO: replace all MaskedField (Phone) on PhoneField, add new validation for phoneValidator
    if (REPAIR_PHONE_REGEXP.test(value) || REPAIR_PHONE_PASTE_REGEXP.test(value)) {
      return;
    }
    return 'Неправильный номер';
  };
};
export var squareMeterValidator = function squareMeterValidator() {
  var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      message: 'Минимальная площадь квартиры 18 м2'
    },
    message = _ref6.message;
  return function (value) {
    if (Number(value) < 18) {
      return message;
    }
    return;
  };
};
export var inSelectOption = function inSelectOption(_ref7) {
  var options = _ref7.options,
    _ref7$message = _ref7.message,
    message = _ref7$message === void 0 ? 'Выберите значение' : _ref7$message;
  return function (selectValue) {
    if (options.find(function (_ref8) {
      var value = _ref8.value;
      return value === selectValue;
    })) {
      return;
    }
    return message;
  };
};
export var inMapValidator = function inMapValidator(_ref9) {
  var map = _ref9.map,
    _ref9$message = _ref9.message,
    message = _ref9$message === void 0 ? 'Выберите значение' : _ref9$message;
  return function (value) {
    if (typeof map.get(value) !== 'undefined') {
      return;
    }
    return message;
  };
};
export var formatAndValidate = function formatAndValidate(transformer, validator) {
  return function (value) {
    return validator(transformer(value));
  };
};
export var dateValidator = function dateValidator() {
  var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref10$message = _ref10.message,
    message = _ref10$message === void 0 ? 'Обязательное поле' : _ref10$message,
    _ref10$format = _ref10.format,
    format = _ref10$format === void 0 ? 'dd.MM.yyyy' : _ref10$format;
  return function (value) {
    if (!value) {
      return;
    }
    if (!isValid(parse(value, format, new Date()))) {
      return message;
    }
    return;
  };
};
export var length = function length(value, message) {
  return function (toValidate) {
    return toValidate.length !== value ? message : undefined;
  };
};
export function pipe() {
  for (var _len3 = arguments.length, validators = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    validators[_key3] = arguments[_key3];
  }
  return function (value) {
    for (var _i = 0, _validators = validators; _i < _validators.length; _i++) {
      var validateFn = _validators[_i];
      var res = validateFn(value);
      if (res) {
        return res;
      }
    }
    return undefined;
  };
}
export var REQUIRED_FIELD = 'Обязательное поле';
export function notEmpty() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : REQUIRED_FIELD;
  return function (value) {
    return !value.trim().length ? message : undefined;
  };
}
export var phoneValidator2 = function phoneValidator2() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "\u0412\u0432\u0435\u0434\u0451\u043D \u043D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440. \u041F\u0440\u0438\u043C\u0435\u0440:\xA0+7\xA0910\xA0123-45-67";
  return function (phone) {
    return pipe(notEmpty(), length(10, message))(phone);
  };
};